import { setModal } from 'actions/modals';
import moment from 'moment';
import { getEnv } from '@xbcb/ui-env';

export default ({ latestAppVersion, minimumAppVersion }) =>
  async (dispatch) => {
    const { REACT_APP_VERSION } = getEnv();
    if (!minimumAppVersion || !REACT_APP_VERSION || !latestAppVersion) {
      return;
    }
    const clientVersion = moment(REACT_APP_VERSION);
    const latestVersion = moment(latestAppVersion);
    const minimumVersion = moment(minimumAppVersion);
    if (
      minimumVersion.diff(latestVersion) > 0 ||
      (clientVersion.diff(minimumVersion) >= 0 &&
        latestVersion.diff(clientVersion, 'days') <= 30)
    ) {
      return;
    }
    await dispatch(
      setModal({
        // TODO add key to `ModalKey` enum if we ended up using this
        key: 'newContentModal',
        props: {
          visible: true,
        },
      }),
    );
  };
